import toFormat from "./toFormat";

export default function toDDMMYYYY(x: Date) {
  return toFormat(x, "dd/MM/yyyy");
}
